export default __webpack_public_path__ + "static/media/utjd-objectives-2023-2024.460dab7e.png";